import { FC, PropsWithChildren } from 'react';

import { NavigationLink } from 'components/NavigationLink';
import { ROUTES } from 'libs/navigation';
import { useUser } from 'libs/providers';
import { Stack } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { useTheme } from 'libs/ui/theme';

import { WrapperStyled } from '../Wrapper.styles';

import { HeaderStyled } from './Header.styles';
import { NavigationMenu } from './NavigationMenu';
import { ThemeSwitch } from './ThemeSwitch';
import { User } from './User';

export interface HeaderProps {
  className?: string;
}

export const Header: FC<HeaderProps & PropsWithChildren> = ({ className }) => {
  const { mode } = useTheme();
  const { client } = useUser();

  const logo =
    mode === 'dark' ? (
      <Icon.LogoDark className="header-logo" />
    ) : (
      <Icon.Logo className="header-logo" />
    );

  return (
    <HeaderStyled className={className}>
      <WrapperStyled className="header-wrapper">
        <Stack
          alignItems="center"
          direction="row"
          spacing={48}
          spacingMobile={16}
        >
          {client?.isAccountOpened ? (
            <>
              <NavigationLink
                className="header-logo-wrapper"
                to={ROUTES.account.orders.fullPath}
              >
                {logo}
              </NavigationLink>
              <NavigationMenu />
            </>
          ) : (
            <div className="header-logo-wrapper">{logo}</div>
          )}
        </Stack>
        <div className="header-right">
          <Stack
            alignItems="center"
            direction="row"
            spacing={32}
            spacingMobile={12}
          >
            <ThemeSwitch />

            <User />
          </Stack>
        </div>
      </WrapperStyled>
    </HeaderStyled>
  );
};
